import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SquareBorderButton, Upload, SnackBarHelper } from '@lyearn-team/frontend-components';
import showFileResponse from 'helper/uppy/fileUploader';
import { UploadButtonWrapper } from './styles';

class FileResponse extends Component {
  static contextTypes = {
    showLoading: PropTypes.func,
    hideLoading: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      fileName: '',
      url: ''
    };
  }

  onDeleteUpload = () => {
    // this.props.deleteUpload();
    this.setState({ fileName: '', url: '' });
  };

  getResponse = () => {
    const response = this.props.deletingResponse
      ? ''
      : this.state.url
      ? JSON.stringify({ url: this.state.url, fileName: this.state.fileName })
      : this.props.response;
    return {
      questionObj: this.props.questionObj,
      emptySubmittedResponse: this.emptySubmittedResponse,
      responseData: {
        questionId: this.props.questionId,
        response,
        fileName: this.state.fileName,
        answerEvaluation: !response || response !== '' ? '' : 'NA',
        responseType: 'FILE',
        deletingResponse: this.props.deletingResponse
      },
      callBack: () => {
        this.props.responseEnterChange(true);
      }
    };
  };

  emptySubmittedResponse = () => {
    this.setState({ fileName: '', url: '' });
  };

  fileUploaded = r => {
    if (!r.url) {
      SnackBarHelper.showSnackbar({
        label: 'File Upload failed, please try again.',
        status: 'error'
      });
      window.analytics.track('FILE_UPLOAD_FAILURE', {
        errorMessage: 'Filestack callback function does not contain url to uploaded file'
      });
      return false;
    }

    const url = r.url;
    const filename = r.filename;
    this.setState(
      {
        fileName: filename,
        url
      },
      () => {
        this.props.saveOneResponse(this.getResponse());
      }
    );
    this.props.responseEnterChange(true);
  };

  uploadFile = () => {
    window.fs_filepicker = window.filestack && window.filestack.init('AuG7ZQSxaSemtziJGYwbsz');
    this.context.showLoading();
    window.fs_filepicker
      .picker({
        fromSources: [
          'local_file_system',
          'url',
          'imagesearch',
          'googledrive',
          'webcam',
          'video',
          'audio'
        ],
        maxFiles: 1,
        minFiles: 1,
        onOpen: () => {
          this.context.hideLoading();
        },
        onFileUploadFailed: (file, error) => {
          window.analytics.track('FILEPICKER_FILE_UPLOAD_FAILED', {
            cardId: this.props.cardId,
            error
          });
        },
        onFileUploadFinished: data => {
          window.analytics.track('FILEPICKER_FILE_UPLOAD_FINISHED', {
            cardId: this.props.cardId,
            fileUploadData: JSON.stringify(data),
            fileUrl: data.url
          });
          this.fileUploaded(data);
        }
      })
      .open();
  };

  render() {
    const { response } = this.props;
    if (response) {
      const { fileName, url } = JSON.parse(response);
      return (
        <Upload
          downloadUrl={url}
          showPreview={true}
          fileName={fileName || url}
          showDelete={false}
        />
      );
    }
    return (
      <UploadButtonWrapper>
        <SquareBorderButton
          text="Upload File"
          icon={{
            type: 'upload',
            style: { width: '18px', marginRight: '6px' }
          }}
          onClick={() => showFileResponse(this.props.cardId, this.fileUploaded, 'upload')}
          type="filled"
        />
      </UploadButtonWrapper>
    );
  }
}

export default FileResponse;
